import React from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../../components/ui/tabs";

export type PerformanceSubTab = {
  label: string;
  value: string;
  content: React.ReactNode;
};

type PerformanceSubTabsProps = {
  tabs: PerformanceSubTab[];
  selectedValue: string;
  onChange: (value: string) => void;
};

const PerformanceSubTabs: React.FC<PerformanceSubTabsProps> = ({
  tabs,
  selectedValue,
  onChange,
}) => {
  return (
    <Tabs value={selectedValue} onValueChange={onChange}>
      <div className="px-2">
        <TabsList className="inline-flex h-8 w-fit shrink-0 items-center gap-0.5 rounded-full border border-border bg-muted p-0.5 text-muted-foreground">
          {tabs.map((tab) => (
            <TabsTrigger
              key={tab.value}
              value={tab.value}
              className="h-7 rounded-full border border-transparent bg-transparent px-3 py-0 text-xs font-medium text-muted-foreground transition-all duration-200 ease-out hover:bg-accent hover:text-foreground data-[state=active]:border-border data-[state=active]:bg-card data-[state=active]:text-foreground data-[state=active]:shadow-sm"
            >
              {tab.label}
            </TabsTrigger>
          ))}
        </TabsList>
      </div>

      {tabs.map((tab) => (
        <TabsContent key={tab.value} value={tab.value} className="pt-2">
          {tab.content}
        </TabsContent>
      ))}
    </Tabs>
  );
};

export default PerformanceSubTabs;
